import useCreditCheckFollowupBoxStyles from '../CreditCheckFollowupBox.styles';
import { Button, mergeClasses } from '@fluentui/react-components';
import BaseInputField from '../../../../../../components/forms/inputs/BaseInputField/BaseInputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

export interface ICreditCheckPhoneNumberInput {
    onClick: () => void;
    phoneNumber: string;
    setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
    title?: string;
    message?: string;
}

const CreditCheckPhoneNumberInput = (props: ICreditCheckPhoneNumberInput) => {
    const { onClick, phoneNumber, setPhoneNumber, title, message } = props;

    const styles = useCreditCheckFollowupBoxStyles();

    return (
        <div className={mergeClasses(styles.followupContainer, styles.informationalStatus)}>
            <h2 className={styles.header}>{title || 'More information needed.'}</h2>
            <p className={styles.callMeInfoText}>
                {message || 'Please provide a good phone number to contact you.'}
            </p>
            <BaseInputField
                name='phoneNumber'
                label='Phone Number'
                className={styles.phoneNumberInput}
                defaultValue={phoneNumber}
                onChange={setPhoneNumber}
            />
            <p className={styles.fadedBodyText}>
                For requests outside normal business hours, we will call you as soon as possible on
                the next business day.
            </p>
            <Button appearance={'primary'} onClick={onClick} className={styles.callMeButton}>
                <FontAwesomeIcon icon={faPhone} className={styles.callMeButtonIcon} />
                Call Me
            </Button>
        </div>
    );
};

export default CreditCheckPhoneNumberInput;
